/* eslint-env browser */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, browserHistory, IndexRedirect } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import store from './stores';

// Template & Page Components
import {
  AccountsPageContainer,
  AccountPlatformsPageContainer,
  JobsPageContainer,
  AdminDatasetsContainer,
  ConfigureFormPage,
  CreateAccountPage,
  ViewAccountContainer,
  CreateOrderPage,
  DataIndex,
  FilesetPageContainer,
  ForgotPasswordPage,
  RenderCurrentHomepage,
  LoginPage,
  MyAccount,
  groupSKUPage,
  NewListContainer,
  OrdersIndexContainer,
  PasswordResetPage,
  PasswordSetPage,
  PricingIndexContainer,
  ProductsIndexContainer,
  Prospecting,
  DataReportsPageContainer,
  SingleDatasetReportsPage,
  ReportViewContainer,
  ActivityReportsPage,
  BillingReportsPage,
  EditAccountPage,
  SuperadminEditPage,
  AccountOrdersPageContainer,
  TemplateContainer,
  UserEditContainer,
  UsersIndexContainer,
  UploadPrematchedContainer,
  TokenPage,
  SingleDatasetContainer,
  SuperadminPricingContainer,
  FilesetPreviewContainer,
  PrivacyPolicy,
  NotFound,
  // Customer Portal Specific
  AdminIndex,
  CreateCustomerAccount,
  UserSettings,
  ViewOrderContainer,
  OrderOverviewReportContainer,
  OrderReportContainer,
  MatchedPairReportContainer,
} from './components';

// Require Sass file so webpack can build it
import './_scss/style.scss';

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

if (typeof window !== 'undefined') {
  const appRoot = document.getElementById('react-root');

  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Route path="/" component={TemplateContainer}>
          <IndexRedirect to="home" />
          <Route path="account/login" component={LoginPage} />
          <Route path="account/myaccount" component={MyAccount} />
          <Route path="activity-reports" component={ActivityReportsPage} />
          <Route path="billing-reports" component={BillingReportsPage} />
          <Route path="data-reports" component={DataReportsPageContainer} />
          <Route path="data" component={DataIndex} />
          <Route path="data/dataset/:datasetId" component={SingleDatasetContainer} />
          <Route path="data/dataset/:datasetId/:page" component={groupSKUPage} />
          <Route path="data/dataset/:datasetId/:page/:fieldsetId" component={groupSKUPage} />
          <Route path="data/filesetPreview/:datasetId" component={FilesetPreviewContainer} />
          <Route path="data/newList/:accountId" component={NewListContainer} />
          <Route path="data/reports/:datasetId" component={SingleDatasetReportsPage} />
          <Route path="editList" component={SuperadminEditPage} />
          <Route path="forgot-password" component={ForgotPasswordPage} />
          <Route path="home" component={RenderCurrentHomepage} />
          <Route path="order-reports" component={OrderOverviewReportContainer} />
          <Route path="order-reports/:orderId" component={OrderReportContainer} />
          <Route path="matched-pair-report/:orderId" component={MatchedPairReportContainer} />
          <Route path="orders" component={OrdersIndexContainer} />
          <Route path="orders/create/:page/:selectedAccountId" component={CreateOrderPage} />
          <Route path="orders/create/:page" component={CreateOrderPage} />
          <Route path="orders/order/:orderId" component={ViewOrderContainer} />
          <Route
            path="orders/order/upload-prematched/:orderId"
            component={UploadPrematchedContainer}
          />
          <Route path="password-reset" component={PasswordResetPage} />
          <Route path="password-set" component={PasswordSetPage} />
          <Route path="platforms" component={ProductsIndexContainer} />
          <Route path="pricing" component={PricingIndexContainer} />
          <Route path="privacy" component={PrivacyPolicy} />
          <Route
            path="reports/report/:datasetId/:version/:reportName/:reportType"
            component={ReportViewContainer}
          />
          <Route path="superadmin/accounts" component={AccountsPageContainer} />
          <Route path="superadmin/accounts/account/:accountId" component={ViewAccountContainer} />
          <Route path="superadmin/accounts/edit/:accountId" component={EditAccountPage} />
          <Route path="superadmin/configurePlatform" component={ConfigureFormPage} />
          <Route path="superadmin/create" component={CreateAccountPage} />
          <Route path="superadmin/filesets/:datasetId" component={FilesetPageContainer} />
          <Route path="superadmin/jobs" component={JobsPageContainer} />
          <Route path="superadmin/listsummary" component={AdminDatasetsContainer} />
          <Route path="superadmin/orders" component={AccountOrdersPageContainer} />
          <Route path="superadmin/platforms" component={AccountPlatformsPageContainer} />
          <Route path="superadmin/pricing" component={SuperadminPricingContainer} />
          <Route path="superadmin/token" component={TokenPage} />
          <Route path="users" component={UsersIndexContainer} />
          <Route path="users/:accountId" component={UsersIndexContainer} />
          <Route path="users/:accountId/edit/:userId" component={UserEditContainer} />
          {/* Customer Portal specific routes */}
          <Route path="/create-user" component={CreateCustomerAccount} />
          <Route path="/user-settings" component={UserSettings} />
          <Route path="/search/:instanceId/:tagFilter" component={Prospecting} />
          <Route path="/search/:instanceId" component={Prospecting} />
          <Route path="/admin/:page" component={AdminIndex} />
          <Route path="/admin/:page/:instanceId" component={AdminIndex} />
          {/* Catch all */}
          <Route path="*" component={NotFound} />
        </Route>
      </Router>
    </Provider>,
    appRoot
  );
}
